var map = {
	"./sample.abap.txt": [
		8192,
		8192
	],
	"./sample.aes.txt": [
		4147,
		4147
	],
	"./sample.apex.txt": [
		43602,
		3602
	],
	"./sample.azcli.txt": [
		53647,
		3647
	],
	"./sample.bat.txt": [
		68531,
		8531
	],
	"./sample.bicep.txt": [
		20311,
		311
	],
	"./sample.brainfuck.txt": [
		3079,
		3079
	],
	"./sample.c.txt": [
		94265,
		4265
	],
	"./sample.cameligo.txt": [
		22475,
		2475
	],
	"./sample.clike.txt": [
		45936,
		5936
	],
	"./sample.clojure.txt": [
		97938,
		7938
	],
	"./sample.coffeescript.txt": [
		77319,
		7319
	],
	"./sample.cpp.txt": [
		97009,
		7009
	],
	"./sample.csharp.txt": [
		80563,
		563
	],
	"./sample.csp.txt": [
		91952,
		1952
	],
	"./sample.css.txt": [
		42303
	],
	"./sample.dart.txt": [
		95545,
		7926
	],
	"./sample.dockerfile.txt": [
		31056,
		1056
	],
	"./sample.ecl.txt": [
		78950,
		8950
	],
	"./sample.elixir.txt": [
		64371,
		4371
	],
	"./sample.erlang.txt": [
		67559,
		7559
	],
	"./sample.flow9.txt": [
		31963,
		1963
	],
	"./sample.freemarker2.txt": [
		44736,
		4736
	],
	"./sample.fsharp.txt": [
		35112,
		5112
	],
	"./sample.go.txt": [
		30572
	],
	"./sample.graphql.txt": [
		75225,
		5225
	],
	"./sample.handlebars.txt": [
		90618,
		618
	],
	"./sample.hcl.txt": [
		89047,
		9047
	],
	"./sample.html.txt": [
		68853
	],
	"./sample.ini.txt": [
		80304,
		304
	],
	"./sample.java.txt": [
		41422
	],
	"./sample.javascript.txt": [
		4067
	],
	"./sample.json.txt": [
		64464
	],
	"./sample.jsx.txt": [
		61133
	],
	"./sample.julia.txt": [
		80065,
		65
	],
	"./sample.kotlin.txt": [
		71205,
		1205
	],
	"./sample.less.txt": [
		43425,
		3425
	],
	"./sample.lex.txt": [
		9937,
		9937
	],
	"./sample.lexon.txt": [
		30666,
		666
	],
	"./sample.liquid.txt": [
		97694,
		7694
	],
	"./sample.livescript.txt": [
		1969,
		1969
	],
	"./sample.lua.txt": [
		41548,
		1548
	],
	"./sample.m3.txt": [
		59674,
		9674
	],
	"./sample.markdown.txt": [
		21521
	],
	"./sample.mips.txt": [
		99359,
		9359
	],
	"./sample.msdax.txt": [
		8153,
		8153
	],
	"./sample.mysql.txt": [
		10364
	],
	"./sample.nginx.txt": [
		30706,
		706
	],
	"./sample.objective-c.txt": [
		7107,
		7107
	],
	"./sample.pascal.txt": [
		36618,
		6618
	],
	"./sample.pascaligo.txt": [
		59661,
		9661
	],
	"./sample.perl.txt": [
		2169,
		2169
	],
	"./sample.pgsql.txt": [
		30807,
		807
	],
	"./sample.php.txt": [
		99350
	],
	"./sample.pla.txt": [
		4063,
		4063
	],
	"./sample.plaintext.txt": [
		10419,
		419
	],
	"./sample.postiats.txt": [
		63909,
		3909
	],
	"./sample.powerquery.txt": [
		32375,
		2375
	],
	"./sample.powershell.txt": [
		98589,
		8589
	],
	"./sample.proto.txt": [
		48756,
		8756
	],
	"./sample.pug.txt": [
		70358,
		358
	],
	"./sample.python.txt": [
		44272
	],
	"./sample.qsharp.txt": [
		37833,
		7833
	],
	"./sample.r.txt": [
		50860,
		860
	],
	"./sample.razor.txt": [
		56082,
		6082
	],
	"./sample.redis.txt": [
		77939,
		7939
	],
	"./sample.redshift.txt": [
		11573,
		1573
	],
	"./sample.restructuredtext.txt": [
		72681,
		2681
	],
	"./sample.ruby.txt": [
		30518,
		518
	],
	"./sample.rust.txt": [
		75356
	],
	"./sample.sb.txt": [
		99273,
		9273
	],
	"./sample.scala.txt": [
		51108,
		1108
	],
	"./sample.scheme.txt": [
		95823,
		5823
	],
	"./sample.scss.txt": [
		56402,
		6402
	],
	"./sample.shell.txt": [
		32464
	],
	"./sample.sol.txt": [
		38592,
		8592
	],
	"./sample.sparql.txt": [
		59961,
		9961
	],
	"./sample.sql.txt": [
		32066,
		2066
	],
	"./sample.st.txt": [
		47695,
		7695
	],
	"./sample.stylus.txt": [
		83240,
		3240
	],
	"./sample.swift.txt": [
		715
	],
	"./sample.systemverilog.txt": [
		35545,
		5545
	],
	"./sample.tcl.txt": [
		3195,
		3195
	],
	"./sample.toml.txt": [
		76854,
		6854
	],
	"./sample.tsx.txt": [
		21871
	],
	"./sample.twig.txt": [
		81421,
		1421
	],
	"./sample.typescript.txt": [
		44355
	],
	"./sample.vb.txt": [
		52766,
		2766
	],
	"./sample.vbscript.txt": [
		14675,
		4675
	],
	"./sample.verilog.txt": [
		83300,
		3300
	],
	"./sample.vue.txt": [
		6150,
		6150
	],
	"./sample.xml.txt": [
		49353,
		9353
	],
	"./sample.yaml.txt": [
		68783,
		8783
	]
};
function webpackAsyncContext(req) {
	if(!__webpack_require__.o(map, req)) {
		return Promise.resolve().then(() => {
			var e = new Error("Cannot find module '" + req + "'");
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		});
	}

	var ids = map[req], id = ids[0];
	return Promise.all(ids.slice(1).map(__webpack_require__.e)).then(() => {
		return __webpack_require__(id);
	});
}
webpackAsyncContext.keys = () => (Object.keys(map));
webpackAsyncContext.id = 39126;
module.exports = webpackAsyncContext;